import axios from 'axios';
import {getCookie} from '@insticator/insticator-ui'; // iui-utils
import {url} from '../../../utils/urls';

const withCredentials = true;
const headers = {
  "Content-Type": "application/json",
  'Accept': 'application/json',
  'Authorization': `Bearer ${getCookie('pub_portal_user')}`
};

const imageHeaders = {
  'Content-Type': 'multipart/form-data'
};

export const approveTrendingNowV2Access = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'TRENDING_NOW_V2' }, { withCredentials });

export const fetchTrendingNowV2Config = ({ siteUUID }) => axios.get(`${url.tnb.url}/trending/v1/${siteUUID}/config`, { withCredentials });

export const fetchTrendingNowV2DisplayConfig = ({ siteId }) => axios.get(`${url.ppa.url}/v1/configs/displayConfig?siteId=${siteId}&productType=TRENDING_NOW_V2`, { withCredentials });

export const updateTrendingNowV2Config = ({ trendingNowId, data }) => axios.post(`${url.tnb.url}/trending/v1/${trendingNowId}/config`, data, { headers, withCredentials });

export const updateTrendingNowV2DisplayConfig = ({ siteId, data }) => axios.put(`${url.ppa.url}/v1/configs/displayConfig?siteId=${siteId}&productType=TRENDING_NOW_V2`, data, { headers, withCredentials });

export const uploadCustomArticleImageFallback = ({ trendingNowId, file }) => axios.post(`${url.tnb.url}/trending/v1/upload/${trendingNowId}/image`, file, { imageHeaders, withCredentials })